import React, { useEffect, useState, useContext } from "react";
import { Card, DatePicker, Modal, Select } from "antd";
import AHPTimePicker from "../../components/Calendar/AHPTimePicker";
import "./MenuFilter.css";
import { AppContext } from "../../context";
import openkit from "openkit";
import AddToCartDialog from "../../components/AddToCart/AddToCartDialog";
import { API_URL } from "../../config/config";
import {
  RESTAURANT,
  RESTAURANT_PEOPLE_SELECT_OPTIONS,
  serviceOptions,
  serviceTime,
} from "./restaurantConstants";
import { FIELD_WIDTH, FIELD_WIDTHS } from "../../config/layoutConfig";
import { useLocation } from "react-router";
import moment from "moment";
import { searchMenus } from "./searchMenus";
import { searchTables } from "./searchTables";

openkit.config.app_url = API_URL;

const MenuFilter = ({ products, setProducts, store }) => {
  const [selectedService, setSelectedService] = useState(null);
  const [reservationDate, setReservationDate] = useState(null);
  const [numberOfPeople, setNumberOfPeople] = useState(1);
  const [isAddedToCartVisible, setIsAddedToCartVisible] = useState(false);
  const [tableProduct, setTableProduct] = useState(null);
  const [filterData, setFilterData] = useState({
    people: 1,
  });
  const [hasTables, setHasTables] = useState(false);
  const [tables, setTables] = useState(0);

  let info = useContext(AppContext);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("people")) {
      const people = parseInt(params.get("people") || info.lodge.people);
      const service = params.get("service") || info.lodge.service;
      const time = params.get("time") || info.lodge.time;
      const date = moment(
        params.get("date") === undefined ? info.lodge.date : params.get("date")
      );
      info.setRestaurant({
        ...info.restaurant,
        people,
        service,
        time,
        date,
      });
    }
  }, []);

  useEffect(() => {
    (async () => {
      let menus = await searchMenus(store.id, info);
      setProducts(menus);
    })();
  }, [info.restaurant]);

  // check table availability
  useEffect(() => {
    (async () => {
      const tables = await searchTables(store.id, info);
      setTables(tables);
    })();
  }, [info.restaurant]);

  // const reserveTable = async () => {
  //   // store.id is registered in gen_name, so that later we can recover this table reservation store
  //   const product = {
  //     id: "mesa_" + store.id,
  //     gen_name: `Mesa`,
  //     gen_price: 0,
  //     status: "cart",
  //     gen_files: [
  //       {
  //         url: "http://ahp.openkit.app/wp-content/uploads/2021/11/table-reservation.jpeg",
  //         alt: "Reserved table",
  //       },
  //     ],
  //   };
  //   setTableProduct(product);
  //   setIsAddedToCartVisible(true);
  // };

  const handleChange = (type, value) => {
    info.setRestaurant({ ...info.restaurant, [type]: value });
  };

  return (
    <>
      <div className="ahp-filter-no-spacing">
        <div className="number-of-people" style={{ marginRight: "30px" }}>
          {/* <div style={{ display: "inline" }}>Pessoas</div> */}
          <div>
            <div style={{ display: "inline", marginTop: 6 }}>
              {info.t("people")}:
            </div>
            <Select
              placeholder=""
              options={RESTAURANT_PEOPLE_SELECT_OPTIONS}
              value={info.restaurant.people}
              width={FIELD_WIDTHS.XS}
              bordered={false}
              onChange={(value) => handleChange("people", value)}
            ></Select>
          </div>
        </div>
        <div>
          <DatePicker
            onChange={(value) => handleChange("date", value)}
            bordered={false}
            allowClear
            value={info.restaurant.date}
          />
        </div>
        <div style={{ marginRight: "30px" }}>
          {info.restaurant.date && (
            <>
              <Select
                placeholder=""
                options={serviceOptions}
                value={info.restaurant.service}
                style={{ width: 140 }}
                onChange={(value) => handleChange("service", value)}
                bordered={false}
                allowClear
              ></Select>
            </>
          )}
        </div>
        <div style={{ marginRight: "30px" }}>
          {info.restaurant.service && (
            <div>
              <AHPTimePicker
                availableTime={
                  serviceTime.find((s) => s.name === info.restaurant.service)
                    .availableTime
                }
                // preferredTime={selectedService.preferredTime}
                setSelectedService={setSelectedService}
                type="restaurant"
              />
            </div>
          )}
        </div>
        {info.restaurant?.time && (
          <>
            {/* <button
              className="ahp-button ahp-table"
              type="button"
              onClick={search}
              disabled={!info.restaurant?.time}
              style={{ height: 32 }}
            >
              Disponibilidade de Menus
            </button> */}
            <button
              type="button"
              className="ahp-button ahp-table"
              onClick={() => setIsAddedToCartVisible(true)}
              disabled={!(tables && tables[0]?.gen_quantity > 0)}
              style={{ height: 32, marginTop: 10 }}
            >
              {tables &&
                tables[0]?.gen_quantity >= RESTAURANT.fewTables &&
                "Reservar mesa"}
              {tables &&
                tables[0]?.gen_quantity > 0 &&
                tables[0]?.gen_quantity < RESTAURANT.fewTables &&
                `(apenas ${tables[0]?.gen_quantity} disponíveis)`}
              {(!tables || tables[0]?.gen_quantity === 0) &&
                `sem mesas disponíveis para reserva`}
            </button>
          </>
        )}
      </div>

      {/* dialog for table reservation */}
      {isAddedToCartVisible && (
        <AddToCartDialog
          entity="restaurant"
          store={store}
          product={tables[0]}
          isAddedToCartVisible={isAddedToCartVisible}
          setIsAddedToCartVisible={setIsAddedToCartVisible}
        />
      )}
    </>
  );
};

export default MenuFilter;
